<template>
  <section class="block" :class="$props.classN">
    <h2 class="title">{{ $props.title }}</h2>
    <h3 class="sub">{{ $props.sub }}</h3>
    <ul class="grid">
      <li v-for="(bl, index) in $props.parks" @click.stop="goToArticle(index)">
        <article>
          <div class="con" :class="imageUrl === '' ? 'aqua' : ''"  :style="{ backgroundImage: 'url(' + (typeof bl.images !== 'undefined' && bl.images[0] ? bl.images[0].url : '') + ')' }">
            <img v-if="bl.images && bl.images.length > 0" :src="typeof bl.images !== 'undefined' && bl.images[0] ? bl.images[0].url : ''" :alt="bl.caption" />
            <h2>{{ bl.name }}</h2>
          </div>
          <div class="body">
            <div class="crumb">
              <a v-for="crumb in bl.breadcrumbs">{{ crumb }}</a>
            </div>
            <p>{{ bl.description | userFriendly }}</p>
            <a class="link" :href="bl.url">View holiday park</a>
          </div>
        </article>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data: function () {
      return {}
  },
  filters: {
      userFriendly: function (value) {
          let doc = new DOMParser().parseFromString(value, 'text/html');
          return doc.body.textContent.replace(/<[^>]*>?/gm, ' ') || "";
      }
  },
  props: {
      parks: Array,
      title: String,
      sub: String,
      classN: String
  },
  methods: {
      goToArticle(i) {
          window.location.href = this.$props.parks[i].url;
      }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.sub {
  font-size: .875rem;
  font-weight: 400;
  margin: 0 0 1.25rem 0;
}

.title {
  margin: 1.25rem 0;
}

ul {
  width: 100%;
  list-style: none;
  margin: 1.25rem 0;
}

p, .crumb {
  font-size: .875rem;
  line-height: 1.25;
  width: 100%;
  margin-bottom: .625rem;
}

li {
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  cursor: pointer;

  &:hover,
  &:focus-within {
    img {
      box-shadow: 0 .125rem 1.25rem 0 $col_aqua;
    }
  }

  &:hover h2 {
    text-decoration: underline;
  }
}

.crumb {
  &:after {
    content: "";
    display: table;
    clear: both;
  }

  a {
    float: left;
    margin-right: .625rem;
    text-transform: uppercase;
    color: $col_black;
    font-weight: 700;
    position: relative;

    &:first-of-type:after {
      content: "";
      position: absolute;
      height: 70%;
      top: 15%;
      right: -.313rem;
      background: $col_black;
      width: .0625rem;
    }
  }
}

.link {
  text-decoration: none;
  font-size: .875rem;
  position: relative;

  &, &:after {
    color: $col_orange;
  }

  &:after {
    content: "\00276F";
    margin-left: .25rem;
  }

  &:hover {
    text-decoration: underline;
  }
}

.con {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 28.563rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 .125rem .25rem $col_oplightblack;

  &.aqua {
    background-color: $col_aqua;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.35);
    width: 100%;
    height: 100%;
  }

  h2 {
    color: $col_white;
    font-weight: 700;
    text-shadow: 0 .125rem .25rem rgba(0,0,0,0.5);
    z-index: 9;
    text-align: center;
    position: relative;
    font-size: 1.5rem;
  }

  img {
    min-width: 100%;
    opacity: 0;
    position: absolute;
    box-shadow: 0 .125rem .25rem $col_oplightblack;
  }
}

@supports (display: grid) {
  ul {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 100%;
    grid-template-columns: repeat(1, 100%);
    row-gap: 1.25rem;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }
}

@media #{$xl-phone} {
  ul {
    -ms-grid-columns: 50%;
    grid-template-columns: repeat(2, calc(50% - 0.625rem));

    .isIE & li {
      float: left;
      width: calc(50% - 1.25rem);
      margin: 0 .625rem 1.25rem;
    }
  }
}

@media #{$desktop} {
  .con h2 {
    font-size: 2.125rem;
  }

  .title {
    font-size: 1.75rem;
  }
}

</style>